"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _evergreenUi = require("evergreen-ui");
var _filterPropTypes = require("./filterPropTypes");
var _TableHeaderCell = _interopRequireDefault(require("./head/TableHeaderCell"));
var _SelectionTableHeaderCell = _interopRequireDefault(require("./head/SelectionTableHeaderCell"));
var _TableCell = _interopRequireDefault(require("./TableCell"));
var _SelectionTableCell = _interopRequireDefault(require("./SelectionTableCell"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // We’re not using Link because Evergreen restyles the links and we want EBI VF for that
// Minimum width of the large size in EBI VF
var ebiVfLargeMinWidth = 1024;
var TableContent = function TableContent(_ref) {
  var dataRows = _ref.dataRows,
    tableHeaders = _ref.tableHeaders,
    tableSecondHeaders = _ref.tableSecondHeaders,
    filters = _ref.filters,
    tableHeaderCellOnChange = _ref.tableHeaderCellOnChange,
    sortColumnIndex = _ref.sortColumnIndex,
    ascendingOrder = _ref.ascendingOrder,
    tableHeaderCellOnClick = _ref.tableHeaderCellOnClick,
    rowSelectionColumn = _ref.rowSelectionColumn,
    selectedRows = _ref.selectedRows,
    host = _ref.host,
    selectOnChange = _ref.selectOnChange,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table, {
    minWidth: ebiVfLargeMinWidth,
    border: true
  }, tableSecondHeaders && /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.Head, {
    height: (0, _evergreenUi.majorScale)(6),
    paddingRight: 0
  }, tableSecondHeaders.map(function (tableHeader, index) {
    return /*#__PURE__*/_react["default"].createElement(_TableHeaderCell["default"], _extends({
      key: index
    }, tableHeader, {
      value: filters[tableHeader.dataKey] || "",
      columnIndex: index,
      sortColumnIndex: sortColumnIndex,
      ascendingOrder: ascendingOrder,
      onClick: tableHeaderCellOnClick,
      onChange: tableHeaderCellOnChange
    }));
  })), /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.Head, {
    height: tableSecondHeaders ? "auto" : (0, _evergreenUi.majorScale)(6),
    paddingRight: 0
  }, tableHeaders.map(function (tableHeader, index) {
    return /*#__PURE__*/_react["default"].createElement(_TableHeaderCell["default"], _extends({
      key: index
    }, tableHeader, {
      value: filters[tableHeader.dataKey] || "",
      columnIndex: index,
      sortColumnIndex: sortColumnIndex,
      ascendingOrder: ascendingOrder,
      onClick: tableHeaderCellOnClick,
      onChange: tableHeaderCellOnChange
    }));
  }), rowSelectionColumn && /*#__PURE__*/_react["default"].createElement(_SelectionTableHeaderCell["default"], _extends({}, rowSelectionColumn, {
    onClick: rowSelectionColumn.tableHeaderCellOnClick,
    selectedRowIds: selectedRows
  }))), /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.Body, null, dataRows.map(function (dataRow, index) {
    return /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.Row, {
      key: index,
      height: "auto",
      backgroundColor: index % 2 === 0 ? "white" : "whiteSmoke"
    }, [tableHeaders.map(function (tableHeader, index) {
      return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        key: index,
        label: tableHeader.label,
        dataRow: dataRow,
        dataKey: tableHeader.dataKey,
        image: tableHeader.image,
        icon: tableHeader.icon,
        host: host,
        linkTo: tableHeader.linkTo,
        width: tableHeader.width
      });
    }), rowSelectionColumn && /*#__PURE__*/_react["default"].createElement(_SelectionTableCell["default"], {
      key: tableHeaders.length + 1,
      dataRow: dataRow,
      dataKey: rowSelectionColumn.dataKey,
      selectedRowIds: selectedRows,
      onChange: selectOnChange,
      width: rowSelectionColumn.width
    })]);
  })))));
};
TableContent.propTypes = {
  // Presentational props
  dataRows: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  tableHeaders: _propTypes["default"].arrayOf(_filterPropTypes.tableHeaderPropTypes),
  // Filter handling
  filters: _propTypes["default"].object.isRequired,
  tableHeaderCellOnChange: _propTypes["default"].func.isRequired,
  // Ordering
  sortColumnIndex: _propTypes["default"].number.isRequired,
  ascendingOrder: _propTypes["default"].bool.isRequired,
  tableHeaderCellOnClick: _propTypes["default"].func.isRequired,
  // Row selection and action on selected rows
  rowSelectionColumn: _propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    dataKey: _propTypes["default"].string.isRequired,
    tableHeaderCellOnClick: _propTypes["default"].func,
    tooltipContent: _propTypes["default"].string,
    width: _propTypes["default"].number
  }),
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  host: _propTypes["default"].string,
  selectOnChange: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string
};
TableContent.defaultProps = {
  host: "",
  className: "small-12 columns"
};
var _default = exports["default"] = TableContent;